/* eslint-disable */
import { Card } from '@material-ui/core';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import showAlert from '../../utils/alert';
import Footer from '../common/Footer';
import Header from '../common/Header';
import AgencyPOForm from './AgencyPOForm';
import { getPOQuery } from './queries/getPO';
import { getPoAttachmentsQuery } from './queries/getPoAttachments';
import { fetchAdvanceRequestPurchaseOrder } from './queries/getAdvanceRequestPurchaseOrder';
import { returnPolicies } from '../../PermissionUtility/ProfilePolicies';

const getAttachmentId = (a) => a?.docId ?? a?.poAttachmentId ?? a?.attachmentId ?? a?.id;

const normalizeAttachmentsResponse = (res) => {
  const raw = res?.data;
  const list = Array.isArray(raw) ? raw : (raw && Array.isArray(raw?.data) ? raw.data : (raw && Array.isArray(raw?.result) ? raw.result : []));
  return list;
};

const initialData = {
  vendorId: '',
  companyId: null,
  address: '',
  currencyId: 1,
  expenseCategoryId: '',
  accountCode: '',
  dateOfService: [],
  levelOnePurpose: '',
  levelTwoPurpose: '',
  budgetCategory: '',
  isAdvancePO: false,
  advancePurchaseOrder: [],
  poAttachmentIds: [],
  plannedVesselRevisionId: '',
  purchaseOrderCrew: [
    {
      crewId: '',
      accountCode:'',
      expenseLineItemId: '',
      plannedVesselId: '',
      amount: '',
      crewCode: '',
      ppeDeliveryRemarks: '',
      id: '',
      ppeCategoryDetails:[], 
      plannedVesselRevisionId:''
    }
  ]
};

/** When true, greys Footer Send PO / Save as Draft / Cancel on this screen. */
const AGENCY_PO_FOOTER_DISABLED = true;

const CreateAgencyPO = ({ mode }) => {
  const [isLoading, setisLoading] = useState(true);
  const [isDraft, setDraft] = useState(false);
  const [isFetchingPo, setisFetchingPo] = useState(false);
  const history = useHistory();
  const { poId } = useParams();
  const [isduplicateloading, setisduplicateloading] = useState(false);
  const [dataObj, setdataObj] = useState(null);
  const [restoredPpeCategoryDetails, setRestoredPpeCategoryDetails] = useState({});
  const [isCrewPage, setisCrewPage] = useState();

  const policies = returnPolicies();

  const isFooterActionsDisabled = AGENCY_PO_FOOTER_DISABLED
    || process.env.REACT_APP_DISABLE_AGENCY_PO_FORM === 'true';

  useEffect(() => {
    setisCrewPage(JSON.parse(localStorage.getItem('isPageHandler')))
    if (policies?.poPolicies?.canEdit === false) {
        history.push('/');
      }
  }, [policies]);

 const mapAdvanceItemsFromApi = (source) => {
    if (!source) return [];
    const arr = Array.isArray(source) ? source : [source];
    return arr.map((item, i) => {
      const dateVal = item?.proformaInvoiceDate;
      const dateStr = dateVal ? (moment(dateVal).isValid() ? moment(dateVal).format('YYYY-MM-DD') : dateVal) : '';
      const rawPaymentTerms = item?.paymentTermsId ?? item?.paymentTerms ?? '';
      return {
        id: item?.id || `adv-${Date.now()}-${i}`,
        purchaseOrderId: item?.purchaseOrderId ?? null,
        arqPoNumber: item?.arqPoNumber ?? null,
        paymentTermsId: rawPaymentTerms != null && rawPaymentTerms !== '' ? String(rawPaymentTerms) : '',
        advanceAmount: item?.advanceAmount ?? '',
        proformaInvoiceNo: item?.proformaInvoiceNo ?? '',
        proformaInvoiceDate: dateStr,
        remarks: item?.remarks ?? item?.advanceRemarks ?? '',
        status: item?.status ?? null,
        arqSeqNo: item?.arqSeqNo ?? 0,
        arqAttachmentIds: Array.isArray(item?.arqAttachmentIds) ? item.arqAttachmentIds : [],
        arqAttachments: Array.isArray(item?.arqAttachments) ? item.arqAttachments : (Array.isArray(item?.advanceAttachments) ? item.advanceAttachments : []),
      };
    });
  };

  const createEditObject = (filteredObj) => {
    let restoredPpeDetails = [];
    let plannedVesselId = '';
    try {
      const filteredObjCopy = JSON.parse(JSON.stringify(filteredObj));
      const crew = filteredObjCopy?.purchaseOrderCrew;
      if (crew?.length > 0) {
        restoredPpeDetails = JSON.parse(JSON.stringify(crew[0].ppeCategoryDetails || []));
        plannedVesselId = JSON.parse(JSON.stringify(crew[0].plannedVesselId || ''));
      }
    } catch (e) {
      // ignore
    }
    //console.log('restoredPpeDetails:', filteredObj);
    setRestoredPpeCategoryDetails({ restoredPpeDetails, plannedVesselId });

    if (filteredObj) {
      const categoryDetails = filteredObj.categoryDetails?.reduce((acc, cur) => ({ ...acc, [cur.key]: cur.value }), {});
      const dateOfService = filteredObj?.dateOfService
        ?.map((item) => {
          if (item?.dateOfServices) {
            return { dateOfServices: moment(item?.dateOfServices).format('YYYY-MM-DD') };
          }
        })
        .filter((i) => i);

     const isAdvancePO = filteredObj?.isAdvancePO ?? false;

     const advanceSource = filteredObj?.advancePurchaseOrder;

  const advancePurchaseOrder =
    advanceSource ? mapAdvanceItemsFromApi(advanceSource) : [];

  const firstCrew = filteredObj?.purchaseOrderCrew?.[0];

  const m = moment(filteredObj?.serviceCompletionDate);
  const serviceCompletionDate =
    m.isValid() ? m.format('YYYY-MM-DD') : '';

  setdataObj({
    ...filteredObj,
    company: filteredObj?.companyId,
    restoredPpeCategoryDetails: { restoredPpeDetails, plannedVesselId },
    ...categoryDetails,
    dateOfService,
    levelOnePurpose: filteredObj?.purposeId,
    levelTwoPurpose: filteredObj?.purposeLevelId,
    isAdvancePO: !!isAdvancePO,
    advancePurchaseOrder,
    poAttachmentIds: filteredObj?.poAttachmentIds ?? [],
    level2Approver: filteredObj?.level2Approver ?? null,
    plannedVesselId:
      filteredObj?.plannedVesselId ?? firstCrew?.plannedVesselId ?? '',
    plannedVesselRevisionId:
      filteredObj?.plannedVesselRevisionId ?? firstCrew?.plannedVesselRevisionId ?? '',
    vesselName:
      filteredObj?.vesselName ?? firstCrew?.vesselName ?? firstCrew?.plannedVesselName ?? '',
    vesselCode:
      filteredObj?.vesselCode ?? firstCrew?.vesselCode ?? firstCrew?.plannedVesselCode ?? '',
    imo: filteredObj?.imo ?? firstCrew?.imo ?? firstCrew?.imoNumber ?? '',
    sapVesselCompanyCode:
      filteredObj?.sapVesselCompanyCode ?? firstCrew?.sapVesselCompanyCode ?? '',
    serviceCompletionDate

  });
    }
    return null;
  };

  useEffect(() => {
    if (poId && mode === 'edit') {
      setisFetchingPo(true);
      getPOQuery(poId)
        .then((res) => {
          const poData = res?.data?.data ?? res?.data;
          if (!poData) {
            setisFetchingPo(false);
            return;
          }
          return Promise.all([
            getPoAttachmentsQuery(poId),
            fetchAdvanceRequestPurchaseOrder(poId)
          ]).then(([attachmentsRes, advanceRes]) => {
            const attachmentList = normalizeAttachmentsResponse(attachmentsRes);
            const poAttachmentIds = (poData?.poAttachmentIds && poData.poAttachmentIds.length > 0)
              ? poData.poAttachmentIds
              : attachmentList.map((a) => getAttachmentId(a)).filter(Boolean);
            const advanceRaw = advanceRes?.data;
            const advanceList = Array.isArray(advanceRaw) ? advanceRaw : (advanceRaw && Array.isArray(advanceRaw?.data) ? advanceRaw.data : (advanceRaw && Array.isArray(advanceRaw?.result) ? advanceRaw.result : []));
            const advancePurchaseOrder = (poData?.advancePurchaseOrder && poData.advancePurchaseOrder.length > 0)
              ? mapAdvanceItemsFromApi(poData.advancePurchaseOrder)
              : mapAdvanceItemsFromApi(advanceList);
            const mergedPoData = {
              ...poData,
              poAttachmentIds: poAttachmentIds.length > 0 ? poAttachmentIds : (poData.poAttachmentIds ?? []),
              advancePurchaseOrder: advancePurchaseOrder.length > 0 ? advancePurchaseOrder : (poData.advancePurchaseOrder ? mapAdvanceItemsFromApi(poData.advancePurchaseOrder) : [])
            };
            createEditObject(mergedPoData);
          }).catch(() => {
            createEditObject(poData);
          }).finally(() => {
            setisFetchingPo(false);
          });
        })
        .catch((err) => {
          setisFetchingPo(false);
          showAlert('Something went wrong', 'error');
        });
    }
    if (mode === 'add') {
      setdataObj(initialData);
      setRestoredPpeCategoryDetails({restoredPpeDetails:[],plannedVesselId:''})
    }
  }, [poId, mode]);

  const handleCancel = () => {
    if (poId && mode === 'edit') {
      history.push(`/po/${poId}`);
    } else {
      history.push('/');
    }
  };
  return (
    <div className="md:w-full">
      <Header
        parentPageLink="/"
        currentPage={`${mode === 'add' ? 'Create' : 'Edit'} Purchase Order`}
        parentPage="Purchase Order List"
        headerName="Purchase Orders"
      />
      {/* Form */}
      <Card className="h-full overflow-visible-custom mx-12" variant="Header">
        <div className="px-12">
          <AgencyPOForm {...{ isDraft, setDraft, dataObj, setisLoading, setisduplicateloading, mode, isFetchingPo, restoredPpeCategoryDetails, setRestoredPpeCategoryDetails, poId }} />
        </div>
      </Card>
      <Footer
        {...{
          isLoading,
          handleCancel,
          isduplicateloading,
          setDraft,
          mode,
          dataFail: dataObj?.isSyncFailure,
          isCrewPage,
          footerActionsDisabled: isFooterActionsDisabled,
          isAgencyPage: true,
          isAgencyPoEditable: true
        }}
        isdraftButton
      />
    </div>
  );
};

export default CreateAgencyPO;
